import axios from 'axios';

export function buildCosFormData(cosSignature, objectKey, file) {
  const formData = new FormData();
  formData.append('key', objectKey);
  formData.append('policy', cosSignature.policy);
  formData.append('q-sign-algorithm', cosSignature.qSignAlgorithm || 'sha1');
  formData.append('q-ak', cosSignature.qAk);
  formData.append('q-sign-time', cosSignature.qKeyTime);
  formData.append('q-key-time', cosSignature.qKeyTime);
  formData.append('q-signature', cosSignature.qSignature);
  formData.append('file', file);
  return formData;
}

/**
 * 直传文件到 COS（POST Object）
 */
export async function uploadToCos(cosSignature, objectKey, file, onUploadProgress) {
  const cosUrl = 'https://' + cosSignature.cosHost;
  const formData = buildCosFormData(cosSignature, objectKey, file);
  await axios.post(cosUrl, formData, {
    onUploadProgress
  });
  return {
    objectKey,
    fileUrl: cosUrl + '/' + objectKey
  };
}
